import { axios } from "@/plugins/http-request.js";

const state = {};

const getters = {};
const actions = {
  getReceiptNumber(_, payload) {
    return axios
      .post(`api/btb_get_receipt_number`, payload)
      .then((res) => res.data);
  },
  getOutboundReceiptNumber(_, payload) {
    return axios
      .post(`api/btb_get_parent_ordernumber`, payload)
      .then((res) => res.data);
  },

  getSkuDropDown(_, payload) {
    return axios
      .get(`api/btb_skus/dropdown_list`, {
        params: payload,
      })
      .then((res) => res.data);
  },
  downloadVariantTemplate() {
    return axios
      .get(`/api/file_download?file_path=fulfillmentb2b/inbound_variant.xlsx`, {
        responseType: "blob",
      })
      .then((res) => res);
  },
  downloadOutboundvariantTemplate() {
    return axios
      .get(
        `/api/file_download?file_path=fulfillmentb2b/outbound_variant.xlsx`,
        {
          responseType: "blob",
        }
      )
      .then((res) => res);
  },

  downloadInboundGoods(_, payload) {
    return axios
      .get(
        `/api/fulfillmentbb/b2b_inbound_received_good_expiry_download?pagination=0`,
        {
          responseType: "blob",
          params: payload,
        }
      )
      .then((res) => res);
  },
  getSkuListBB(_, payload) {
    return axios
      .get(`api/btb_sku_variant/list`, {
        params: payload,
      })
      .then((res) => res.data);
  },
  getSkuListSearch(_, payload) {
    return axios
      .get(`api/btb_sku_search/list`, {
        params: payload,
      })
      .then((res) => res.data);
  },
  getSkuEditData(_, id) {
    return axios.get(`/api/btb_sku_variant/edit/${id}`).then((res) => res.data);
  },
  getSkuImages(_, payload) {
    return axios
      .get(`api/btb_sku_image`, {
        params: payload,
      })
      .then((res) => res.data);
  },
  getInboundList(_, payload) {
    return axios
      .get(`api/btb_inbound_variant_list`, {
        params: payload,
      })
      .then((res) => res.data);
  },
  getoutboundList(_, payload) {
    return axios
      .get(`api/btb_outbound_variant_item_list`, {
        params: payload,
      })
      .then((res) => res.data);
  },
  labelingUpdate(_, payload) {
    return axios
      .post(`api/btb_inbound_variant/update_labelling`, payload)
      .then((res) => res.data);
  },
  inboundTimelineSummary(_, id) {
    return axios
      .get(`api/btb_inbound_variant_timeline?inbound_variant_id=${id}`)
      .then((res) => res.data);
  },

  uploadReceipt(_, payload) {
    return axios
      .post(`api/btb_inbound_variant/upload`, payload)
      .then((res) => res.data);
  },
  uploadoutboundReceipt(_, payload) {
    return axios
      .post(`api/btb_outbound_variant/upload`, payload)
      .then((res) => res.data);
  },
  uploadSkuBB(_, payload) {
    return axios
      .post(`api/btb_sku_variant/create`, payload)
      .then((res) => res.data);
  },
  updateSkuBB(_, payload) {
    return axios
      .patch(`api/btb_sku_variant/update/${payload.record_id}`, payload.data)
      .then((res) => res.data);
  },
  uploadSkuBarcode(_, payload) {
    return axios
      .post(`api/btb_sku_barcode/upload`, payload)
      .then((res) => res.data);
  },
  downloadBarcodeTemplate(_, url) {
    return axios
      .get(url, {
        responseType: "blob",
      })

      .then((res) => res);
  },
  linkedSkuBB(_, payload) {
    return axios
      .post(`api/btb_sku_image/link_unlink`, payload)
      .then((res) => res.data);
  },
  inboundVarientSummary(_, payload) {
    return axios
      .get(`api/btb_inbound_variant_summary`, {
        params: payload,
      })
      .then((res) => res.data);
  },
  outboundVariantList(_, payload) {
    return axios
      .get(`api/btb_outbound_variant_list`, {
        params: payload,
      })
      .then((res) => res.data);
  },
  syncSkuVariant(_, id) {
    return axios.get(`api/btb_sku_variant_sync/${id}`).then((res) => res.data);
  },
  inboundSync(_, payload) {
    return axios
      .get(`/api/fulfillmentbb/b2b_inbound_sync?warehouse=${payload.warehouse}`)
      .then((res) => res.data);
  },
  inboundSummarySyncRow(_, payload) {
    return axios
      .get(
        `/api/fulfillmentbb/inbound_report_summary_sync?inbound_id=${payload.inbound_id}`
      )
      .then((res) => res.data);
  },
  inboundSummarySync(_, payload) {
    return axios
      .get(
        `/api/fulfillmentbb/inbound_report_summary_sync?warehouse=${payload.warehouse}`
      )
      .then((res) => res.data);
  },
  getTransactionInboundList(_, payload) {
    return axios
      .get(
        `/api/fulfillmentbb/b2b_inbound_transaction?transaction_type=${payload.type}&inbound_id=${payload.inbound_id}`,
        {
          params: payload,
        }
      )
      .then((res) => res.data);
  },
  inboundGoodsSync(_, payload) {
    return axios
      .get(
        `/api/fulfillmentbb/b2b_inbound_received_good_expiry_sync?client_id=${payload.client_id}&warehouse=${payload.warehouse}`
      )
      .then((res) => res.data);
  },
  inboundCancel(_, payload) {
    return axios
      .post(`/api/fulfillmentbb/inbound_cancel`, payload)
      .then((res) => res.data);
  },
  outboundCancel(_, payload) {
    return axios
      .post(`/api/fulfillmentbb/outbound_cancel`, payload)
      .then((res) => res.data);
  },
  outboundShip(_, payload) {
    return axios
      .post(`/api/fulfillmentbb/ship_outbound_order`, payload)
      .then((res) => res.data);
  },
  inboundReceive(_, payload) {
    return axios
      .post(`/api/fulfillmentbb/inbound_receive`, payload)
      .then((res) => res.data);
  },
  outboundSync(_, payload) {
    return axios
      .get(
        `/api/fulfillmentbb/b2b_outbound_sync?client_id=${payload.client_id}&warehouse=${payload.warehouse}`
      )
      .then((res) => res.data);
  },
  outboundAllocation(_, payload) {
    return axios
      .post(`/api/fulfillmentbb/outbound_allocation`, payload)
      .then((res) => res.data);
  },
  getTypeList(_, payload) {
    return axios
      .get(
        `/api/fulfillmentbb/b2b_dropdown?status_type=${payload.status_type}&warehouse_id=${payload.warehouse_id}`
      )
      .then((res) => res.data);
  },
};

const mutations = {};

export default {
  state,
  getters,
  actions,
  mutations,
};
